import siteType from "../configs/siteType"

/* eslint-disable */
let register = {}
if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "{club}에 오신 것을 환영합니다",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "등록 후 클럽에 가입할 수 있습니다",
    "LAB_REGISTER_USERNAME": "사용자이름",
    "LAB_AUTH_EMAIL": "이메일",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "잘못된 이메일 형식",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "* 이 이메일은 이미 등록에 사용됐습니다.",
    "LAB_KYC_INVALID_EMAIL": "이 이메일 주소는 사용할 수 없습니다.",
    "LAB_ACCOUNT_FORMAT_TIP": "*사용자 이름에는 4~30개의 영어 문자 또는 숫자 문자가 필요합니다",
    "LAB_ACCOUNT_FORMAT_TIP2": "*사용자 이름에는 공백이나 특수 문자가 필요하지 않습니다",
    "LAB_PASSWORD": "비밀번호",
    "LAB_REGISTER_PASSWORD_TIP2": "비밀번호는 6 - 16자여야 하며 영문자와 숫자를 최소 1개 포함해야 합니다.",
    "LAB_REGISTER_PASSWORD_TIP3": "비밀번호에 사용할 수 없습니다: {word}",
    "LAB_REGISTER_PASSWORD_TIP4": "스페이스는 비밀번호에 사용할 수 없습니다.",
    "LAB_CLUB_INVITE_H5_Verifiy": "인증 코드",
    "LAB_VERIFICATION_CODE_ERROR": "잘못된 인증 코드입니다",
    "LAB_REGISTER_RIGHT_NOW": "등록",
    "LAB_CLUB_INVITE_H5_Download_1": "계정이 있으십니까?",
    "LAB_CLUB_INVITE_H5_Download_2": "지금 다운로드하세요",
    "LAB_CLUB_INVITE_H5_Success": "등록 성공",
    "LAB_CLUB_CHECK_TEMS1": "여기를 클릭하여 본인이 18세 이상이며 다음 내용을 읽고 동의함을 확정하세요: ",
    "LAB_CLUB_CHECK_TEMS2": "서비스 약관",
    "LAB_CLUB_CHECK_TEMS3": "및",
    "LAB_CLUB_CHECK_TEMS4": "개인정보 보호정책",
    "LAB_CLUB_CHECK_TIPS": "서비스 약관 및 개인정보 보호정책에 동의함을 표시해 주세요",
    "LAB_REGISTER_MUCH": "중복 등록은 금지돼 있습니다!",
    "LAB_CLUB_INVITE_CODE_ERROR": "초대 코드 오류!",
    "LAB_HISTORY_SHARE_ERROR": "요청에 실패했습니다. 나중에 다시 시도하세요.",
    "LAB_H5_Marketing_Programme": "제휴 마케팅 프로그램 약관 및 조건",
    "LAB_H5_CHECK_TIPS": "여기를 클릭해 본인 연령이 18세 이상이며, {link1}과 {link2}, {link3}을 읽고 동의함을 확인하세요.",
    "LAB_PLAY_NOW": "지금 즐겨보세요!",
    "LAB_TITLE_1": "캐시백 보장",
    "LAB_CONTENT_1": "게임을 끝낸 후 항상 최대 50%의 즉시 레이크백을 받을 수 있습니다!",
    "LAB_TITLE_2": "글로벌 플레이어",
    "LAB_CONTENT_2": "다양하고 흥미진진한 게임이 연중무휴로 계속됩니다!",
    "LAB_TITLE_3": "논스톱 보너스",
    "LAB_CONTENT_3": "순위표, 캐시 스톰, 미션 및 잭팟의 거대한 보상을 받으세요.",
    "LAB_TITLE_4": "자금 보호",
    "LAB_CONTENT_4": "맨 섬 도박 관리 위원회의 티어 1 온라인 포커 라이선스를 취득했습니다.",
    "LAB_BE_MORE": "NUTS POKER에서 플레이어 그 이상이 되세요!",
    "LAB_PLAY_BEST": "지금 최고의 포커 게임을 즐기세요!",
    "LAB_SERVICE": "(웹 사이트, 태블릿, 모바일 애플리케이션을 통해) NUTS POKER가 제공하는 제품과 서비스는 ‘서비스’로 통칭됩니다.",
    "LAB_ENJOY": "다양한 \n포커 형식",
    "LAB_MORE": "NLH, PLO, OFC 등 다수!",
    "LAB_PLAY_GAME": "함께 다양한 포커 게임을 즐기세요!",
    "LAB_MODE": "클래식부터 트렌디한 게임까지, 무제한 텍사스 홀덤, PLO, 6+, OFC 등 다양한 포커 게임을 즐길 수 있으며, 어그레시브, 얼티밋, 조커 모드와 같은 스릴 넘치는 변형 게임도 제공합니다.",
    "LAB_TODAY": "오늘 참가하세요!",
    "LAB_ACTION": "세 배의 액션\n세 배의 재미",
    "LAB_MASTER": "멀티 테이블의 마스터가 되세요",
    "LAB_SAME_TIME": "멀티 테이블 기능으로 한 기기에서 \n최대 세 테이블까지 동시에 즐길 수 있습니다!",
    "LAB_SWIPE": "최상의 경험을 위해, 본인 차례가 되면 테이블이 자동으로 강조 표시되어\n스와이프 한 번에 다음 행동 장소로 이동할 수 있습니다.",
    "LAB_SAFE": "안전하고 공정한\n게임 경험",
    "LAB_ASSEM": "치트 방지 전담 팀 배치!",
    "LAB_RULES": "NUTS POKER는 불공정한 플레이에 대해 무관용 원칙을 적용하며,\n규칙 위반이 확인된 계정을 영구 정지합니다.",
    "LAB_TABLES": "부정 행위 감지를 위해 치트 방지 메커니즘이 구현되어 있으며, \n전문가 팀이 테이블을 모니터링합니다.",
    "LAB_EVERY_DAY": "매일 NUTS POKER에서 공정하고 안전한 게임을 즐기세요!",
    "LAB_ACCESS": "{link} 국민 또는 거주자의 경우, 서비스 이용이 불법일 수 있습니다. 본 내용에 따라 제공되는 서비스는, 베팅, 게임 또는 기타 서비스 사용이 금지된 관할권에서 해당 활동이나 가입을 위한 NUTS POKER의 제안, 권유 또는 초대로 간주되지 않습니다. 특히 미국 국민이나 거주자는 서비스를 이용할 수 없습니다.",
    "LAB_BRAND": "NUTS POKER는 AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD에서 소유한 브랜드 및 등록 사업명입니다.",
    "LAB_GAMEBLING": "온라인 도박에 의거하여 맨 섬 도박 관리 위원회의 규제 및 라이선스를 받았습니다",
    "LAB_AGE": "2019년 7월 24일 이후 온라인 도박 규제 조항 2001(최종 갱신: 2019년 7월 24일)에 따름. 18세 미만의 미성년자는 계정을 만들거나 도박에 참가할 수 없습니다. NUTS POKER의 모든 예치금과 수익은 안전하게 보관되며, 맨 섬 법률에 따라 집행됩니다.",
    "LAB_FOLLOW": "FOLLOW US",
    "LAB_COUNTRIES": "특정 국가",
    "LAB_ABOUT": "정보",
    "LAB_POLICY": "개인정보 보호정책",
    "LAB_TERM": "서비스 약관",
    "LAB_COPY": "Copyright © {link} NUTS POKER. 모든 권리 보유.",
    "LAB_DOWNLOAD": "다운로드",
    "LAB_VERIFICATION": "인증",
    "LAB_PLEASE_TYPE": "이미지에 텍스트를 입력해주세요",
    "LAB_CONFIRM": "확인",
    "LAB_SERVICE_CO": "(웹사이트, 태블릿, 모바일 애플리케이션을 통해) NUTS POKER Global이 제공하는 제품과 서비스는 ‘서비스’로 통칭됩니다.",
    "LAB_ACCESS_CO": "{link} 국민 또는 거주자의 경우, 서비스 이용이 불법일 수 있습니다. 본 내용에 따라 제공되는 서비스는, 베팅, 게임 또는 기타 서비스 사용이 금지된 관할권에서 해당 활동이나 가입을 위한 NUTS POKER Global의 제안, 권유 또는 초대로 간주되지 않습니다. 특히 미국 국민이나 거주자는 서비스를 이용할 수 없습니다.",
    "LAB_GAMEBLING_CO": "NUTS POKER Global의 모든 예치금과 수익은 안전하게 보관되며, 퀴라소의 법률에 따라 집행됩니다.",
    "LAB_AGE_CO": "18세 미만의 미성년자는 계정을 만들거나 도박에 참가할 수 없습니다.",
    "LAB_CLUB_CHECK_TEMS4_CO": "개인정보 및 개인 데이터 관리",
    "LAB_PRIVACYPOLICE_CO": "개인정보 및 개인 데이터",
    "LAB_CONTENT_4_CO": "Curaçao eGaming에 의해 전적으로 라이선스 및 규제를 따릅니다.",
    "LAB_VERIFY_EMAIL": "이메일 인증",
    "LAB_VERIFY_EMAIL_ADDRESS": "{email address}으로 이메일을 보냈습니다",
    "LAB_VERIFY_TIPS": "이메일 주소 인증과 계정 활성화를 위해, 귀하의 이메일로 전송된 인증 링크를 클릭하세요. 스팸 폴더에 있을 수 있습니다.",
    "LAB_VERIFY_RESEND": "이메일 다시 보내기",
    "LAB_VERIFY_CODE_TIPS": "이미지에 표시된 텍스트를 입력해 로봇이 아님을 인증하세요.",
    "LAB_EMAIL_VERIFIED": "이메일 인증됨",
    "LAB_EMAIL_DOWNLOAD_TIPS": "계정이 생성됐습니다. <br>아래의 버튼을 클릭해 NUTS POKER를 다운로드하고 게임을 시작하세요.",
    "LAB_EMAIL_DOWNLOAD": "NUTS POKER 다운로드",
    "LAB_EMAIL_VERIFY_ACCOUNT": "NUTS POKER 계정 인증",
    "LAB_EMAIL_EXPIRED_1": "앗, 링크가 만료됐습니다",
    "LAB_EMAIL_EXPIRED_2": "등록 페이지에서 새 링크를 요청하세요.",
    "LAB_VERIFY_PROTECT": "당사가 개인 정보를 보호하는 방법",
    "LAB_EMAIL_FAILED": "실패했습니다. 나중에 다시 시도하세요"
  }
} else {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "{club}에 오신 것을 환영합니다",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "등록 후 클럽에 가입할 수 있습니다",
    "LAB_REGISTER_USERNAME": "사용자이름",
    "LAB_AUTH_EMAIL": "이메일",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "잘못된 이메일 형식",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "* 이 이메일은 이미 등록에 사용됐습니다.",
    "LAB_KYC_INVALID_EMAIL": "이 이메일 주소는 사용할 수 없습니다.",
    "LAB_ACCOUNT_FORMAT_TIP": "*사용자 이름에는 4~30개의 영어 문자 또는 숫자 문자가 필요합니다",
    "LAB_ACCOUNT_FORMAT_TIP2": "*사용자 이름에는 공백이나 특수 문자가 필요하지 않습니다",
    "LAB_PASSWORD": "비밀번호",
    "LAB_REGISTER_PASSWORD_TIP2": "비밀번호는 6 - 16자여야 하며 영문자와 숫자를 최소 1개 포함해야 합니다.",
    "LAB_REGISTER_PASSWORD_TIP3": "비밀번호에 사용할 수 없습니다: {word}",
    "LAB_REGISTER_PASSWORD_TIP4": "스페이스는 비밀번호에 사용할 수 없습니다.",
    "LAB_CLUB_INVITE_H5_Verifiy": "인증 코드",
    "LAB_VERIFICATION_CODE_ERROR": "잘못된 인증 코드입니다",
    "LAB_REGISTER_RIGHT_NOW": "등록",
    "LAB_CLUB_INVITE_H5_Download_1": "계정이 있으십니까?",
    "LAB_CLUB_INVITE_H5_Download_2": "지금 다운로드하세요",
    "LAB_CLUB_INVITE_H5_Success": "등록 성공",
    "LAB_CLUB_CHECK_TEMS1": "여기를 클릭하여 본인이 18세 이상이며 다음 내용을 읽고 동의함을 확정하세요: ",
    "LAB_CLUB_CHECK_TEMS2": "서비스 약관",
    "LAB_CLUB_CHECK_TEMS3": "및",
    "LAB_CLUB_CHECK_TEMS4": "개인정보 보호정책",
    "LAB_CLUB_CHECK_TIPS": "서비스 약관 및 개인정보 보호정책에 동의함을 표시해 주세요",
    "LAB_REGISTER_MUCH": "중복 등록은 금지돼 있습니다!",
    "LAB_CLUB_INVITE_CODE_ERROR": "초대 코드 오류!",
    "LAB_HISTORY_SHARE_ERROR": "요청에 실패했습니다. 나중에 다시 시도하세요.",
    "LAB_H5_Marketing_Programme": "제휴 마케팅 프로그램 약관 및 조건",
    "LAB_H5_CHECK_TIPS": "여기를 클릭해 본인 연령이 18세 이상이며, {link1}과 {link2}, {link3}을 읽고 동의함을 확인하세요.",
    "LAB_PLAY_NOW": "지금 즐겨보세요!",
    "LAB_TITLE_1": "캐시백 보장",
    "LAB_CONTENT_1": "게임을 끝낸 후 항상 최대 50%의 즉시 레이크백을 받을 수 있습니다!",
    "LAB_TITLE_2": "글로벌 플레이어",
    "LAB_CONTENT_2": "다양하고 흥미진진한 게임이 연중무휴로 계속됩니다!",
    "LAB_TITLE_3": "논스톱 보너스",
    "LAB_CONTENT_3": "순위표, 캐시 스톰, 미션 및 잭팟의 거대한 보상을 받으세요.",
    "LAB_TITLE_4": "자금 보호",
    "LAB_CONTENT_4": "맨 섬 도박 관리 위원회의 티어 1 온라인 포커 라이선스를 취득했습니다.",
    "LAB_BE_MORE": "KKPoker에서 플레이어 그 이상이 되세요!",
    "LAB_PLAY_BEST": "지금 최고의 포커 게임을 즐기세요!",
    "LAB_SERVICE": "(웹 사이트, 태블릿, 모바일 애플리케이션을 통해) KKPoker가 제공하는 제품과 서비스는 ‘서비스’로 통칭됩니다.",
    "LAB_ENJOY": "다양한 \r\n포커 형식",
    "LAB_MORE": "NLH, PLO, OFC 등 다수!",
    "LAB_PLAY_GAME": "함께 다양한 포커 게임을 즐기세요!",
    "LAB_MODE": "클래식부터 트렌디한 게임까지, 무제한 텍사스 홀덤, PLO, 6+, OFC 등 다양한 포커 게임을 즐길 수 있으며, 어그레시브, 얼티밋, 조커 모드와 같은 스릴 넘치는 변형 게임도 제공합니다.",
    "LAB_TODAY": "오늘 참가하세요!",
    "LAB_ACTION": "세 배의 액션\r\n세 배의 재미",
    "LAB_MASTER": "멀티 테이블의 마스터가 되세요",
    "LAB_SAME_TIME": "멀티 테이블 기능으로 한 기기에서 \r\n최대 세 테이블까지 동시에 즐길 수 있습니다!",
    "LAB_SWIPE": "최상의 경험을 위해, 본인 차례가 되면 테이블이 자동으로 강조 표시되어\r\n스와이프 한 번에 다음 행동 장소로 이동할 수 있습니다.",
    "LAB_SAFE": "안전하고 공정한\r\n게임 경험",
    "LAB_ASSEM": "치트 방지 전담 팀 배치!",
    "LAB_RULES": "KKPoker는 불공정한 플레이에 대해 무관용 원칙을 적용하며,\r\n규칙 위반이 확인된 계정을 영구 정지합니다.",
    "LAB_TABLES": "부정 행위 감지를 위해 치트 방지 메커니즘이 구현되어 있으며, \r\n전문가 팀이 테이블을 모니터링합니다.",
    "LAB_EVERY_DAY": "매일 KKPoker에서 공정하고 안전한 게임을 즐기세요!",
    "LAB_ACCESS": "{link} 국민 또는 거주자의 경우, 서비스 이용이 불법일 수 있습니다. 본 내용에 따라 제공되는 서비스는, 베팅, 게임 또는 기타 서비스 사용이 금지된 관할권에서 해당 활동이나 가입을 위한 KKPoker의 제안, 권유 또는 초대로 간주되지 않습니다. 특히 미국 국민이나 거주자는 서비스를 이용할 수 없습니다.",
    "LAB_BRAND": "KKPoker는 AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD에서 소유한 브랜드 및 등록 사업명입니다.",
    "LAB_GAMEBLING": "온라인 도박에 의거하여 맨 섬 도박 관리 위원회의 규제 및 라이선스를 받았습니다",
    "LAB_AGE": "2019년 7월 24일 이후 온라인 도박 규제 조항 2001(최종 갱신: 2019년 7월 24일)에 따름. 18세 미만의 미성년자는 계정을 만들거나 도박에 참가할 수 없습니다. KKPoker의 모든 예치금과 수익은 안전하게 보관되며, 맨 섬 법률에 따라 집행됩니다.",
    "LAB_FOLLOW": "FOLLOW US",
    "LAB_COUNTRIES": "특정 국가",
    "LAB_ABOUT": "정보",
    "LAB_POLICY": "개인정보 보호정책",
    "LAB_TERM": "서비스 약관",
    "LAB_COPY": "Copyright © {link} KKPoker. 모든 권리 보유.",
    "LAB_DOWNLOAD": "다운로드",
    "LAB_VERIFICATION": "인증",
    "LAB_PLEASE_TYPE": "이미지에 텍스트를 입력해주세요",
    "LAB_CONFIRM": "확인",
    "LAB_SERVICE_CO": "(웹사이트, 태블릿, 모바일 애플리케이션을 통해) KKPoker Global이 제공하는 제품과 서비스는 ‘서비스’로 통칭됩니다.",
    "LAB_ACCESS_CO": "{link} 국민 또는 거주자의 경우, 서비스 이용이 불법일 수 있습니다. 본 내용에 따라 제공되는 서비스는, 베팅, 게임 또는 기타 서비스 사용이 금지된 관할권에서 해당 활동이나 가입을 위한 KKPoker Global의 제안, 권유 또는 초대로 간주되지 않습니다. 특히 미국 국민이나 거주자는 서비스를 이용할 수 없습니다.",
    "LAB_BRAND_CO": "kkpoker.co는 퀴라소의 Perseusweg 27A, Willemstad에서 158923번으로 등록된 Violet Fortune Tech Limited N.V에 의해 운영됩니다. 이 웹사이트는 퀴라소 e게이밍(퀴라소 라이선스 1668번 JAZ 퀴라소 e게이밍 발급)에 의해 라이선스를 취득하였으며 해당 규제를 준수합니다.",
    "LAB_GAMEBLING_CO": "KKPoker Global의 모든 예치금과 수익은 안전하게 보관되며, 퀴라소의 법률에 따라 집행됩니다.",
    "LAB_AGE_CO": "18세 미만의 미성년자는 계정을 만들거나 도박에 참가할 수 없습니다.",
    "LAB_CLUB_CHECK_TEMS4_CO": "개인정보 및 개인 데이터 관리",
    "LAB_PRIVACYPOLICE_CO": "개인정보 및 개인 데이터",
    "LAB_CONTENT_4_CO": "Curaçao eGaming에 의해 전적으로 라이선스 및 규제를 따릅니다.",
    "LAB_VERIFY_EMAIL": "이메일 인증",
    "LAB_VERIFY_EMAIL_ADDRESS": "{email address}으로 이메일을 보냈습니다",
    "LAB_VERIFY_TIPS": "이메일 주소 인증과 계정 활성화를 위해, 귀하의 이메일로 전송된 인증 링크를 클릭하세요. 스팸 폴더에 있을 수 있습니다.",
    "LAB_VERIFY_RESEND": "이메일 다시 보내기",
    "LAB_VERIFY_CODE_TIPS": "이미지에 표시된 텍스트를 입력해 로봇이 아님을 인증하세요.",
    "LAB_EMAIL_VERIFIED": "이메일 인증됨",
    "LAB_EMAIL_DOWNLOAD_TIPS": "계정이 생성됐습니다. <br>아래의 버튼을 클릭해 KKPoker를 다운로드하고 게임을 시작하세요.",
    "LAB_EMAIL_DOWNLOAD": "KKPoker 다운로드",
    "LAB_EMAIL_VERIFY_ACCOUNT": "KKPoker 계정 인증",
    "LAB_EMAIL_EXPIRED_1": "앗, 링크가 만료됐습니다",
    "LAB_EMAIL_EXPIRED_2": "등록 페이지에서 새 링크를 요청하세요.",
    "LAB_VERIFY_PROTECT": "당사가 개인 정보를 보호하는 방법",
    "LAB_EMAIL_FAILED": "실패했습니다. 나중에 다시 시도하세요"
  }
}

export default {
  "register": register
}